export default __webpack_public_path__ + "static/media/tactor-ports.be609dad.svg";